// extracted by mini-css-extract-plugin
export default {"th":"WalletStocksList_th__Rum9+","td":"WalletStocksList_td__NUSXO","emphasis":"WalletStocksList_emphasis__-H6gr"};